import { StyleSheet } from 'react-native';
import { brand, neutrals, alert } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    height: '100%',
    paddingTop: 24,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 16,
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.black,
  },
  counter: {
    paddingHorizontal: 7,
    backgroundColor: neutrals.white,
    color: brand.main.water,
    borderRadius: 20,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
  },
  textLink: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    borderWidth: 0,
    borderColor: brand.main.water,
  },
  textLinkUnderlined: {
    textDecorationLine: 'underline',
  },
  spinner: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  fullscreenOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopStartRadius: 20,
    borderTopEndRadius: 20,
  },
  errorWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 16,
    gap: 4,
  },
  errorWrapperBottom: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 16,
  },
  errorInnerWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  errorTitle: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
  },
  errorDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
    paddingLeft: 24,
  },
  errorDescriptionCenter: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
  },
  icon: {
    width: 16,
    height: 16,
  },
  errorTextLink: {
    color: alert.alertRed,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    borderBottomWidth: 1,
    borderStyle: 'dotted',
    borderColor: alert.alertRed,
  },
});
